import 'next/stylesheets/components/toast';

import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-toast', {
  mixins: [eventListenerMixin],

  properties: {
    active: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.dismiss = this.querySelector('.toast-dismiss');
    this.listenTo(this.dismiss, 'click', this.removeToast.bind(this));
    this.removeAll();
    this.timer = setTimeout(() => {
      this.active = true;
      this.setTimer();
    }, 300);
  },

  setTimer() {
    this.timer = setTimeout(() => {
      this.listenTo(this, 'transitionend', () => this.remove());
      this.active = false;
      this.timer = null;
    }, 5000);
  },

  removeAll() {
    Array.prototype.forEach.call(document.querySelectorAll('tr-toast[active]'), (toast) => {
      toast.removeToast();
    });
  },

  removeToast() {
    this.listenTo(this, 'transitionend', () => this.remove());
    this.active = false;
  },

  disconnected() {
    this.stopListening();
    if (this.timer) clearTimeout(this.timer);
  },
});
